import React from 'react'
import MessageSnackbar from '../../utils/snackBar/snackBar'
import Tasks from '../tasks/task'
import Navbar from '../navbar/navbar'
import Profile from './profileDetails/profile'
import CreateRequest from './requests/newRequest/newRequestContainer'
import RequestList from './requests/request'
import './StudentDashboard.scss'
import StudentDashboard from './student/dashboard'

const StudentDashboardContainer = () => {

    return (
        <>
            <Navbar></Navbar>
            <StudentDashboard></StudentDashboard>
            <div className="grid-container">
                <div className="grid-item-1 w-100 ">
                    <CreateRequest></CreateRequest>
                </div>
                <div className="grid-item-2">
                    <RequestList></RequestList>
                </div>
                <div className="grid-item-3 w-100">
                    <Tasks></Tasks>
                </div>
                <div className="grid-item-4 w-100">
                    <Profile></Profile>
                </div>
            </div>
        </>
    )

}
export default StudentDashboardContainer